<template>

  <v-text-field
      :class="timePickerClass"
      ref="input"
      variant="underlined"
      :disabled="disabled"
      :append-icon="undefined"
      :id="id"
      :rules="timeRules"
      :label="pickerTitle"
      :prepend-icon="prependIcon ?? 'access_time'"
      v-model="timeValue"
      :clearable="clearable"
      @keydown.enter.prevent="sendValue()"
      @blur="sendValue()"
      dense
  >
  </v-text-field>

</template>
<script>
import i18n from "@/localization/i18n"
const t = i18n.global.t
const timeRegex = /^([01]?\d|2[0-3]):([0-5]?\d)$/;

export default {
  name: "TimePicker",
  props: {
    id: String,
    neighborId: String,
    rules: Array,
    modelValue: String,
    title: String,
    minTime: String,
    maxTime: String,
    clearable: Boolean,
    prependIcon: String,
    class: String,
    disabled: Boolean,
    required: Boolean,
  },
  emits: ["update:modelValue", "update:valid"],
  computed: {
    timeRules(){
      let allRules = []
      if (this.rules){
        allRules.push(...this.rules)
      }
      if (this.minTime && this.maxTime){
        allRules.push(this.isTimeInRange)
      }
      if (this.required) {
        allRules.push(this.requiredRule)
      }
      allRules.push(this.timeFormatRule)
      return allRules
    },
    isMinMaxValidated(){
      const minTime = this.$props.minTime
      const maxTime = this.$props.maxTime
      if(minTime && maxTime){
        const minTimeInMinutes = this.calculateMinutes(minTime);
        const maxTimeInMinutes = this.calculateMinutes(maxTime);
        if(minTimeInMinutes <= maxTimeInMinutes){
          return true
        } else {
          console.error('minTime must be smaller than maxTime')
          return false
        }
      } else {
        return true
      }
    },
    isTimePropsFormatValidated(){
      if(this.modelValue){
        if(timeRegex.test(this.modelValue) === false){
          console.error('modelValue has bad format. Enter valid format 06:30')
          return false
        }
      }
      if(this.minTime){
        if(timeRegex.test(this.minTime) === false){
          console.error('minTime has bad format. Enter valid format 06:30')
          return false
        }
      }
      if(this.maxTime){
        if(timeRegex.test(this.maxTime) === false){
          console.error('maxTime has bad format. Enter valid format 06:30')
          return false
        }
      }
      return true
    }
  },

  created() {
    this.fixFormat()
    this.validate()
  },

  data() {
    return {
      timeValue: this.modelValue ?? '',
      pickerTitle: this.title ? this.title : 'Čas',
      timePickerClass: ''
    };
  },

  watch: {
    modelValue(newValue) {
      this.timeValue = newValue ?? ''
      this.fixFormat()
      this.validate()
    },

  },

  methods: {
    async validate() {
      await this.$refs.input?.validate()
      const isValid = this.$refs.input?.isValid
      this.$emit('update:valid', isValid)
    },
    async sendValue() {
      this.fixFormat()
      await this.validate()
      this.$emit('update:modelValue', this.timeValue)
    },
    timeFormatRule(value){
      if(!value || timeRegex.test(value)){
        return true
      } else {
        return t('time_picker.bad_time_format')
      }
    },
    requiredRule(value) {
      return !!value || t('time_picker.required')
    },
    isTimeInRange(value){
      if(value){
        const minTime = this.$props.minTime
        const maxTime = this.$props.maxTime

        const timeInMinutes = this.calculateMinutes(value)
        const minTimeInMinutes = this.calculateMinutes(minTime)
        const maxTimeInMinutes = this.calculateMinutes(maxTime)

        if (timeInMinutes >= minTimeInMinutes && timeInMinutes <= maxTimeInMinutes){
          return true
        } else {
          return t("time_picker.bad_time_range") + minTime + ' - ' + maxTime
        }
      } else {
        return true
      }
    },
    calculateMinutes(time){
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    },
    fixFormat() {
      // add missing colon
      const fourDigitsRegex = /^\d{3,4}$/
      if (fourDigitsRegex.test(this.timeValue)) {
        const divider = this.timeValue.length === 3 ? 1 : 2
        this.timeValue = (
            this.timeValue.substring(0, divider) +
            ':' +
            this.timeValue.substring(divider, 4)
        )
      }

      // add missing leading zeros (only if the time is not empty and valid)
      if (this.timeValue && this.timeFormatRule(this.timeValue) === true) {
        const [hours, minutes] = this.timeValue.split(':');
        this.timeValue = (
            (hours.length === 1 ? '0' + hours : hours) +
            ':' +
            (minutes.length === 1 ? '0' + minutes : minutes)
        )
      }
    },
  },
};
</script>

<style scoped>
.hideTimePicker {
  display: none;
}
</style>